

































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  DxDataGrid,
  DxEditing,
  DxStateStoring,
} from 'devextreme-vue/data-grid';
import DxFileUploader from 'devextreme-vue/file-uploader';
import {
  SuppliersClient,
  ContactBasicsDto,
  RawMaterialsClient,
  ImportRawMaterialsDataCommand,
  ImportRawMaterialDataDto,
  IImportRawMaterialDataDto,
} from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import Card from '@/components/default/Card.vue';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    DxFileUploader,
    Popup,
    Card,
  },
})
export default class ImportRawMaterialsFileDialog extends Vue {
  private supplier: ContactBasicsDto | null = null;
  private loading: boolean = true;
  private saving: boolean = false;
  private show: boolean = false;
  private guidList: any[] = [];
  private data: any = null;

  public open(supplier: ContactBasicsDto) {
    this.supplier = supplier;
    this.data = null;
    setTimeout(() => {
      this.show = true;
    }, 300);
  }

  private async save() {
    try {
      this.saving = true;
      const client = new RawMaterialsClient(undefined, this.$axios);
      const importData: ImportRawMaterialDataDto[] = [];
      this.data.data.forEach((data: IImportRawMaterialDataDto) => {
        const entry = new ImportRawMaterialDataDto();
        entry.init(data);
        importData.push(entry);
      });
      await client.importData(new ImportRawMaterialsDataCommand({
        supplierId: this.supplier!.id,
        data: importData,
      }));

      this.show = false;
      notificationService.showSuccessMessage('Prijzen zijn aangepast');
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private async uploadChunk(file: any, uploadInfo: any) {
    try {
      const item = this.guidList.find((i) => i.name === file.name);

      const dto: IUploadChunkDto = {
        file: uploadInfo.chunkBlob,
        path: '',
        metaData: {
          index: uploadInfo.chunkIndex,
          totalCount: uploadInfo.chunkCount,
          fileSize: file.size,
          fileType: file.type,
          fileName: file.name,
          fileGuid: item ? item.guid : '',
        },
      };

      const result = (await this.upload('', dto)).data;

      const guidItems = this.guidList.filter((guidItem) => guidItem.name === file.name);
      if (guidItems.length > 0) {
        if (result.completed) {
          guidItems.forEach((guidItem) => {
            const index = this.guidList.indexOf(guidItem);
            this.guidList.splice(index, 1);
          });

          this.data = (result as any).data;
        }
      } else {
        if (!result.completed) {
          this.guidList.push({
            name: file.name,
            guid: result.guid,
          });
        } else {
          this.data = (result as any).data;
        }
      }

      if (result.completed) {
        notificationService.showSuccessMessage('Bestand is geüpload');
        /*this.$emit('uploaded');
        this.hide();*/
      }
    } catch (err) {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het uploaden');
    }
  }

  private upload(supplierId: string, payload: IUploadChunkDto) {
      const formDataToUpload = new FormData();
      formDataToUpload.append('file', payload.file, payload.metaData.fileName);
      formDataToUpload.append('path', '');
      formDataToUpload.append('objectId', this.supplier!.id!);
      formDataToUpload.append('metaData[index]', '' + payload.metaData.index);
      formDataToUpload.append('metaData[totalCount]', '' + payload.metaData.totalCount);
      formDataToUpload.append('metaData[fileSize]', '' + payload.metaData.fileSize);
      formDataToUpload.append('metaData[fileName]', '' + payload.metaData.fileName);
      formDataToUpload.append('metaData[fileType]', '' + payload.metaData.fileType);
      formDataToUpload.append('metaData[fileGuid]', '' + payload.metaData.fileGuid);
      return this.$axios.post<IUploadChunkResult>(`/Api/RawMaterials/ImportFile`,
          formDataToUpload, {
          headers: {'Content-Type': 'multipart/form-data' },
      });
  }
}
